module.exports = __webpack_public_path__ + "static/media/mainButton.96c081cf.png";